angular.module('cvsApp').service('patientInfoService',['networkService', 'xdrService', 'configManager', 'patientInfoModel', 'cvsAppData', function (NS, XS,CM, PIM, CAD) {
   	
	function patientInfoService (){
		this.getPatientInformationData = function(callBackSuccess,guestTokenID){
			//get url

			var tokenId, tokenType;
			/*var tokenId=CAD.getTokenId();
			 var tokenType=CAD.getTokenType();*/
			try{
				tokenId = CAD.getTokenId() ? CAD.getTokenId() : (guestTokenID || cvsUtility.queryMap.tokenId);
				tokenType = CAD.getTokenType() ? CAD.getTokenType() : ((guestTokenID) ? 'Guest' : 'Login');
			}
			catch(ex){
				tokenId = guestTokenID || cvsUtility.queryMap.tokenId;
				tokenType = (guestTokenID) ? 'Guest' : 'Login';
			}
			// var url = CM.getAGPAPIUrl('AGP_GET_PATIENT_INFORMATION');
			var url = CVS.Config.serviceHost[cvsUtility.queryMap.env]+"SPLAGPv1/patientDetails/getPatientInformation/v7";
			if(cvsUtility.queryMap.env === 'local'){
				url = CVS.Config.serviceHost[cvsUtility.queryMap.env] +"specialty/SPLAGPv1/patientDetails/getPatientInformation/v7";
			}
			if(url === "URL_ERROR"){

			}else{
				var request = {
                    url: url,
                    header: {
                        "Content-Type": "application/json",
                        "Accept":"application/json"
                    },
                    data: getRequestBody(tokenId, tokenType),
                    onSuccess: callBackSuccess
                }
			
				cvsUtility.commonServiceCode(url,"getPatientInformation",PIM,request,callBackSuccess,NS);
			}
						
		}

		var getRequestBody = function(tokenId, tokenType){
			var apikey = CAD.hasOwnProperty('getApiKey') && CAD.getApiKey() ? CAD.getApiKey() : cvsUtility.queryMap.apikey;
			var reqObj = {
                "getPatientInformationRequest": {
                    "header": {
                        "serviceContext": {
                            "appName": cvsUtility.queryMap.mobileAppStyle ? 'SPL_APP' : 'SPL_WEB',
                            "lineOfBusiness": "Specialty",
                            "channelName": cvsUtility.queryMap.channel,
							"responseFormat": "JSON",
							"type": "SPLSBMS",
							"bkAppName": "patientService",
							"tokenID" : tokenId,
							"tokenType": CM.getAGPTokenType(tokenType)
							
                        },
                        "securityContext": {
                            "apiKey": apikey,
                            "securityType": "apiKey"
                        }
                    },
					"details": {}
                }
			};
			
			return reqObj;
			}
	
	}
	
	return new patientInfoService();	
}]);
